export default "__VITE_ASSET__DkQUGD5___"